export interface Brand {
  id: number;
  slug: string;
  sortOrder: number;
  isActive: boolean;
  showLabel: boolean;
  name: string;
  logo: string;
  banner: string;
  createdAt: Date;
  updatedAt: Date;
}

export const brandFromResponse = (responseData: any): Brand => ({
  id: responseData.id,
  slug: responseData.slug,
  sortOrder: responseData.sort_order,
  isActive: responseData.is_active === 1,
  showLabel: !!responseData.show_label,
  name: responseData.name,
  logo: responseData.path,
  banner: responseData.banner,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
